// extracted by mini-css-extract-plugin
export var blockassetLogo = "BlockassetLogo_blockassetLogo__TjVsX";
export var textBlockasset = "BlockassetLogo_textBlockasset__Gxoei";
export var textMarketplace = "BlockassetLogo_textMarketplace__S-aRJ";
export var rotate = "BlockassetLogo_rotate__-3BZe";
export var dotty = "BlockassetLogo_dotty__DrNET";